const o="patrocinado",a={ads:o};export{o as SPONSORED_PRODUCT_SEARCH_PARAM_VALUE,a as SPONSORED_PRODUCT_URL_SEARCH_PARAMS};
